import { useState } from "react";
import Title from "../components/ui/Title";
import '../styles/pages/field.scss';

const FieldNotes = () => {

    const [section, setSection] = useState(0)

    return (
        <div className="page-container"
            style={{paddingBottom: '50px'}}
        >
            <div className="section-nav">
                <div className="border-wrapper">
                <h1 className="section-title">
                    Sections: <br/>
                </h1>
                <div className="section-nav_list">
                    <button className="section-nav_button" onClick={()=>{
                        setSection(0)
                    }}>
                        SSS
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(1)
                    }}>
                        Bracer Guild
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(2)
                    }}>
                        Testaments
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(3)
                    }}>
                        Saber Vipers
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(4)
                    }}>
                        Revache
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(5)
                    }}>
                        Heiyue
                    </button>
                    <button className="section-nav_button" onClick={()=>{
                        setSection(6)
                    }}>
                    Red Constellation
                    </button>
                </div>
                </div>
            </div>
            <Title text={Titles[section]}/>
            <div className="notes-container">
                <div className="content-wrapper">
                    {section === 0 && <SSS/>}
                    {section === 1 && <Bracer/>}
                    {section === 2 && <Testaments/>}
                    {section === 3 && <Vipers/> }
                    {section === 4 && <Revache/>}
                    {section === 5 && <Heiyue/>}
                    {section === 6 && <Red/>}
                </div>
            </div>
        </div>
    )
}

const Titles = [
    "SSS Field Notes",
    "Bracer Guild Field Notes",
    "Testaments Field Notes",
    "Saber Vipers Field Notes",
    "Revache Field Notes",
    "Heiyue Field Notes",
    "Red Constellation Field Notes",
]

const SSS = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/sss.webp`} alt="" />
            </div>
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/lloyd.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/elie.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/randy.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/tio.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/wazy.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/noel.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            While far from complete, these field notes are a way for the SSS to catalog our intel regarding the organizations, criminal or otherwise, that inhabit Crossbell City. As we learn more about these different groups, we will add to these notes in order to support our efforts in assisting the citizens of this city*.
        </p>
        <p className="side-note">
            *Lloyd’s note: This information has since been supplemented by an…unexpected contributor and will accordingly reflect the most current data available to the SSS.
        </p>
        <p className="main-text">
            Information is still being obtained and all notes are subject to review by Section Chief Sergei Lou.
        </p>
    </>
)

const Bracer = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/bracer.webp`} alt="" />
            </div>
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/arios.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            An international non-governmental organization with branches all across the continent, the Bracer Guild’s goal is to keep the peace and protect civilians. As this overlaps with our own directives somewhat, they could be seen as the biggest competitor to the SSS. Although to be honest, this rivalry is a bit one-sided in the Bracers Guild’s favor at the moment.
        </p>
        <p className="side-note">
            *Lloyd’s note: Although this organization is a competitor of ours, in the face of recent events, we've received much support and cooperation from their members; most notably S-rank bracer Arios MacLaine. At this time, I’d like to think this is much less a “rivalry” and more of a mutual camaraderie.
        </p>
        <p className="main-text">
            Due to the stellar track record of their Crossbell branch and the impeccable work of the internationally-famous bracer, Arios MacLaine, the Bracer Guild has become the first group citizens will turn to when they’re in need of help**. Two new transfers include Estelle and Joshua Bright.***
        </p>
        <p className="side-note">
            **Lloyd’s note: In light of recent events, it seems as though the citizens of Crossbell are now more aware of us and are willing to turn to us for assistance.
        </p>
        <p className="side-note">
            ***Lloyd's note: As of writing this post, Estelle and Josh have since transferred and are no longer affiliated with the Crossbell branch of the Bracer Guild.
        </p>
    </>
)

const Testaments = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/testaments.webp`} alt="" />
            </div>
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/abbas.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            A group of delinquents located in the Downtown District of Crossbell City, the Testaments fancy themselves as intellectuals. Their calm and collected leader, Wazy Hemisphere, has earned himself quite the loyal (and at times, passionate) following, one that the SSS will need to monitor closely moving forward*.
        </p>
        <p className="side-note">
            *Lloyd’s note: Ever since their leader, Wazy Hemisphere, joined our team, the Testaments have turned into a reliable source of information for the goings-on in Crossbell.
        </p>
        <p className="main-text">
            It seems the Trinity bar, run by the second in command Abbas, is the Testaments' base of operations, and they refer to this location as their “holy ground.” Not exactly the words I’d use to describe a bar, but it does track with the religious motif this group has adopted.
        </p>
        <p className="main-text">
            The group has a bitter rivalry with the Saber Vipers, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt**.
        </p>
        <p className="side-note">
            *Lloyd’s note: Between the Testaments’ cooperation with us and the assistance of the Bracer Guild, we’ve had a much easier time regulating the turbulent activities of the two groups.
        </p>
    </>
)

const Vipers = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/vipers.webp`} alt="" />
            </div>
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/wald.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            A group of delinquents located in the Downtown District of Crossbell City, the Saber Vipers are very rough around the edges. Its members are almost always looking for a fight, due in large part to their hot-headed (and youthful) leader, Wald Wales. That being said, he may be the only one strong enough to keep a group like this in line*.
        </p>
        <p className="side-note">
            *Lloyd’s note: As of late, Wald Wales has been in a depressive, and at times agitated, state since Wazy Hemisphere left the Downtown District to join the SSS. However, I worry he could still pose a threat to the city…
        </p>
        <p className="main-text">
            The Saber Vipers have occupied an abandoned warehouse named Ignis, and have been using it as their headquarters. The loud music being blasted from the building during all hours of the day is fairly unmistakable…
        </p>
        <p className="main-text">
            The group has a bitter rivalry with the Testaments, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt**.
        </p>
        <p className="side-note">
            *Lloyd’s note: With Wazy joining the SSS and the continued support of the Bracer Guild, we’ve had a much easier time keeping the peace between these two groups.
        </p>
    </>
)

const Revache = () => (
    <>
        <div className="image-section">
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/garcia.png`} alt="" />
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/don.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            Revache is an influential mafia organization that has controlled the black market of Crossbell City for many years. Its leader, Don Marconi, is a friend of Speaker Hartmann*, an important figure in Crossbell’s government. This is how Marconi and his right-hand man, Garcia Rossi, are able to engage so freely in all their criminal acts.
        </p>
        <p className="side-note">
            *Lloyd’s note: Former speaker, as of writing this update.
        </p>
        <p className="main-text">
            The Crossbell Police Department is well aware of the connection between Hartmann and Marconi, but the number of corrupt politicians and officials who answer to them have certainly made things difficult for the CPD. If Revache were to start a war with Heiyue for control of Crossbell’s criminal underground, it would pose a grave threat that even the SSS may not be able to handle**.
        </p>
        <p className="side-note">
            *Lloyd’s note: Following recent events, Revache has finally been disbanded, and a majority of its members have been arrested. This organization plagued the city of Crossbell for 70 years using various underhanded methods such as gunrunning, mira laundering, and even smuggling drugs.
        </p>
    </>   
)

const Heiyue = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/heiyue.webp`} alt="" />
            </div>
            <div className="members">
                <img src={`${process.env.PUBLIC_URL}/img/characters/field/cao.png`} alt="" />
            </div>
        </div>
        <p className="main-text">
            Hailing from Calvard, Heiyue is a crime syndicate trying to wrestle control of Crossbell’s black market away from Revache. On paper, it’s a simple trading company by the name of Heiyue Trading, Ltd., but this is merely a front for the group’s criminal activities. Our…sources suspect that the cunning and tenacious branch manager, Cao Lee, was the one who came up with this idea. The legendary assassin known only as Yin is also allied with Heiyue, further adding to the questions and threats posed by this organization*.
        </p>
        <p className="side-note">
            *Lloyd’s note: Despite our previous efforts, the fall of Revache seems to have created an opportunity for Heiyue to grow and fill the power vacuum in the city. Based on the intel we’ve gathered so far, it looks like Cao is striving to strengthen their position…
        </p>
    </> 
)

const Red = () => (
    <>
        <div className="image-section">
            <div className="emblem">
                <img src={`${process.env.PUBLIC_URL}/img/emblems/red.webp`} alt="" />
            </div>
        </div>
        <p className="main-text">
            A large and powerful jaeger corps, perhaps one of the strongest in all of western Zemuria, according to Detective Dudley. We’ve been unable to verify their origins, and their true intentions are also a mystery. I can’t help but wonder why they’re in Crossbell and what they aim to gain. Randy didn’t seem as surprised by their presence as the rest of us, though… I’ll need to follow up on that.
        </p>
    </>
)

export default FieldNotes;